import React from "react";
import { useLocation, withRouter } from "react-router-dom";
import PrintPage from "../../../../components/common/PrintPage/PrintPage";
import CustomTable from "../../../../components/common/Table/CustomTable";

const ExportPdf = () => {
  const location = useLocation();

  return (
    <PrintPage className={location?.state?.from}>
      <CustomTable
        columns={location?.state?.columns}
        data={location?.state?.data}
      />
    </PrintPage>
  );
};

export default withRouter(ExportPdf);
